import { Descriptions } from 'antd';
import { LONG_VIDEO_DURATION } from '../../common/settings';
import { useAuthority } from '../../me/hook';
import {
  videoModelSpecs,
  type GenerationType,
  type ModelSpec,
} from '../model-spec';

function getDurations(
  duration: ModelSpec['duration'],
  long_video: boolean,
  generation_type?: GenerationType,
) {
  if (Array.isArray(duration)) {
    return duration.map((num) => `${num}秒`).join('、');
  }

  return `${duration.min}-${long_video && generation_type === 'reference' ? LONG_VIDEO_DURATION : duration.max}秒`;
}

export const DurationTooltip = (props: {
  generationType?: GenerationType;
  isLongVideoSupported?: boolean;
}) => {
  const authority = useAuthority();

  return (
    <Descriptions
      column={1}
      size="small"
      bordered
      items={[
        ...videoModelSpecs
          .entries()
          .filter(([_, spec]) => !spec.deprecated)
          .filter(([_, spec]) => authority(spec.permission))
          .filter(([_, spec]) => {
            if (props.generationType == null) {
              return true;
            }

            if (props.generationType === 'reference') {
              return spec.reference_image;
            } else {
              return spec.frame_image;
            }
          })
          .map(([model, spec]) => ({
            key: model,
            label: videoModelSpecs.get(model)?.name,
            children: getDurations(
              spec.duration,
              !!spec.long_video && !!props.isLongVideoSupported,
              props.generationType,
            ),
          })),
      ]}
    ></Descriptions>
  );
};
